import React, { useContext } from 'react';
import routes from 'src/constants/routes';
import { AuthorizationContext } from 'src/contexts/authorizationContext';
import Text from 'src/components/Text';
import Link from 'src/components/Link';
import LogoutLink from './LogoutLink';
import styles from './styles.module.scss';

const PublicMenu: React.FC = () => {
  const authorizationState = useContext(AuthorizationContext);
  const userId = authorizationState?.userId;

  return (
    <nav>
      <ul className={styles['link-list']}>
        <li className={styles['link-item']}>
          <Text type="span">{userId}</Text>
        </li>
        <li className={styles['link-item']}>
          <Link to={routes.accountProfile} className={styles['link']}>
            Профиль
          </Link>
        </li>
        <li className={styles['link-item']}>
          <LogoutLink className={styles['link']} />
        </li>
      </ul>
    </nav>
  );
};

export default PublicMenu;
